import React from 'react';

const SOURCE_LABELS = {
  ai: 'AI',
  chat_upload: 'Upload',
  template: 'Template',
  lawyer: 'Lawyer',
  client: 'Client',
};

export function ProjectDocumentsList({files = [], driveFolderUrl = '', t}) {
  const list = Array.isArray(files) ? files.filter((f) => f?.url || f?.fileId) : [];
  const title = t ? t('project.documentsSection') : 'Documents';

  return (
    <div className="sidebar-section sidebar-section--documents">
      <h3 className="sidebar-section-title">{title}</h3>
      {list.length === 0 ? (
        driveFolderUrl ? (
          <a href={driveFolderUrl} target="_blank" rel="noopener noreferrer" className="sidebar-link">
            {t ? t('project.openDriveFolder') : 'Open Drive folder'}
          </a>
        ) : (
          <p className="sidebar-kv-value sidebar-kv-value--muted">—</p>
        )
      ) : (
        <ul className="sidebar-doc-list">
          {list.map((file) => (
            <li key={file.fileId || file.url} className="sidebar-doc-item">
              <a href={file.url} target="_blank" rel="noopener noreferrer">
                {file.name || file.fileId}
              </a>
              <span className="sidebar-doc-source">
                {SOURCE_LABELS[file.source] || file.source || ''}
              </span>
            </li>
          ))}
        </ul>
      )}
      {list.length > 0 && driveFolderUrl ? (
        <div className="sidebar-section-actions sidebar-section-actions--end">
          <a href={driveFolderUrl} target="_blank" rel="noopener noreferrer" className="sidebar-link">
            {t ? t('project.openDriveFolder') : 'Open Drive folder'} ›
          </a>
        </div>
      ) : null}
    </div>
  );
}
